import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';
import TickSolid from '@simplywallst/ui-core/icons/TickSolid';
import { Menu } from '@simplywallst/ui-core/next';

export type Props = {
  onChange: (value: number) => void;
  timePeriod: number;
};

const options = [
  { value: 3, label: '3 Years' },
  { value: 5, label: '5 Years' },
  { value: 10, label: '10 Years' },
];

export const NarrativeMiniValuatorTimePeriodSelector = ({
  onChange,
  timePeriod,
}: Props) => {
  return (
    <Menu
      label={
        <button className="focus-outline rounded-md">
          <div className="grid grid-cols-[auto_24px] items-center">
            <span className="text-xs font-strong text-softer">
              {options.find((option) => option.value === timePeriod)?.label ??
                ''}
            </span>
            <span className="sr-only">time period</span>
            <ChevronDownSmallSolid className="fill-softer" />
          </div>
        </button>
      }
    >
      {options.map((option) => (
        <Menu.Item
          key={option.value}
          onAction={() => onChange(option.value)}
          isSelected={timePeriod === option.value}
          textValue={option.label}
        >
          <div className="grid grid-cols-[24px_auto] items-center">
            {timePeriod === option.value ? (
              <TickSolid className="size-x2 fill-softer" />
            ) : (
              <div />
            )}
            <span>{option.label}</span>
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );
};
